<template><!--个人中心》安全中心》修改密码/设置支付密码-->
    <div class="updatePassword">
        <div class="joinAddress-box">
				<div class="joinaddress-content-box">
					<div class="joinaddress-top popup-title-p dis-between">
						<p style="margin:auto 0" v-if="parentName.type == 1">修改登录密码</p>
                        <p style="margin:auto 0" v-else-if="parentName.type == 2">设置支付密码</p>
						<p @click="closeaddress">×</p>
					</div>
                    <div style="height:20px"></div>
                        <div class="receipt-box">
                            <div class="reg-box">
                                <div class="register-item-mobile">
                                    <input
                                        type="tel"
                                        placeholder="请输入手机号"
                                        v-model="usertel"
                                        oninput="if(value.length>11)value=value.slice(0,11)"
                                        disabled
                                    />
                                </div>
                                <div class="register-item-code clearfix">
                                    <input
                                        type="text"
                                        placeholder="请输验证码"
                                        v-model="vcode"
                                        oninput="if(value.length>6)value=value.slice(0,6)"
                                    />
                                    <div
                                        class="send-btn"
                                        @click="sendcode"
                                        v-show="codeflag"
                                    >
                                        发送验证码
                                    </div>
                                    <div
                                        class="send-btn"
                                        v-show="!codeflag"
                                    >
                                        {{count}}秒后重发
                                    </div>
                                </div>
                                <div v-if="parentName.type == 1">
                                    <div class="register-item-pwd">
                                        <input
                                            type="password"
                                            placeholder="请输入8位密码,字母/数字"
                                            v-model="password"
                                        />
                                    </div>
                                    <div class="register-item-pwd">
                                        <input
                                            type="password"
                                            placeholder="请再次输入密码"
                                            v-model="Qpassword"
                                        />
                                    </div>
                                </div>
                                <div v-else-if="parentName.type == 2">
                                    <div class="register-item-pwd">
                                        <input
                                            type="password"
                                            placeholder="请输入6位数字密码"
                                            v-model="password"
                                            maxlength="6"
                                            oninput="value=value.replace(/[^\d]/g,'')"
                                        />
                                    </div>
                                    <div class="register-item-pwd">
                                        <input
                                            type="password"
                                            placeholder="请再次输入密码"
                                            v-model="Qpassword"
                                            maxlength="6"
                                            oninput="value=value.replace(/[^\d]/g,'')"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div style="height:30px"></div>
                            <el-button @click="butReq" size="small" type="success" v-if="parentName.type == 1">修改</el-button>
                            <el-button @click="butReq" size="small" type="success" v-else-if="parentName.type == 2">确认</el-button>
                        </div>
					</div>
				</div>
			</div>
    </div>
</template>

<style scoped>
    .reg-box {
        width:60%;
        height: auto;
    }
    .register-item-mobile {
        /* margin-top: 3.125rem; */
        margin-top: 0
    }

    .register-item-mobile input {
        /* width: 22.5rem; */
        width: 100%;
        height: 2.3rem;
        /* background: #F2F4FF; */
        background: #f5f5f5;
        border-radius: 8px;
        border: none;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 16px;
        line-height: 2.3rem;
        color: #333;
    }

    .register-item-code {
        /* width: 22.5rem; */
        width: 100%;
        margin-top: 1rem;
    }

    .register-item-code input {
        float: left;
        /* width: 9.5rem; */
        height: 2.3rem;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 16px;
        border: none;
        background: #F2F4FF;
        border-radius: 8px;
    }

    .send-btn {
        float: right;
        width: 8.75rem;
        border-radius: 8px;
        font-size: 16px;
        color: #434343;
        line-height: 2.3rem;
        text-align: center;
        float: right;
        background-color: #F2F4FF;
        cursor: pointer;
    }

    .register-item-pwd {
        margin-top: 0;
    }

    .register-item-pwd input {
        width: 100%;
        height: 2.3rem;
        background: #F2F4FF;
        border-radius: 8px;
        border: none;
        padding-left: 1rem;
        padding-right: 1rem;
        font-size: 16px;
        line-height: 2.3rem;
        color: #333;
        margin: 1rem 0 0 0
    }

    .register-agreement {
        width: 22.5rem;
        margin-top: 1rem;
    }
    input {
        outline: none;
    }
</style>

<script>
    export default
    {
        name: 'updatePassword',
        props: { parentName: { type: Object } },
        data()
        {
            return {
                count: 60, //验证码倒计时
                codeflag: true,
                password: "", //密码
                Qpassword: "", //确认密码
                vcode: "", //验证码
                usertel: '', //手机号
                codevalue: '', //后台获取的验证码
                
                //+--------------------------------------------------------
                bol: false,
            };
        },
        created()
        {
            let loginData2 = JSON.parse( localStorage.getItem( 'loginData2' ) )
            this.usertel = loginData2.phone
        },
        methods:
        {
            sendcode()
            { //发送验证码
                let telReg = /^1[3|4|5|6|7|8|9]\d{9}$/;
                let name = ''
                if ( this.usertel == '' )
                {
                    name = '请输入手机号！';
                    this.checkTips( name, 'warning' );
                }
                else if ( !telReg.test( this.usertel ) )
                {
                    name = '手机号格式错误！';
                    this.checkTips( name, 'warning' );
                }
                else
                {
                    let params = {
                        mobile: this.usertel,
                        RegistrationType: 2,
                    }
                    this.$api.user.sendCode( params ).then( res =>
                    {
                        console.log( res )
                        if ( res.data.code === 0 )
                        {
                            let name = res.data.message;
                            this.checkTips( name, 'success' );
                            sessionStorage.setItem( 'code', res.data.result );
                            const TIME_COUNT = 60;
                            if ( !this.timer )
                            {
                                this.count = TIME_COUNT;
                                this.codeflag = false;
                                this.timer = setInterval( () =>
                                {
                                    if ( this.count > 0 && this.count <= TIME_COUNT )
                                    {
                                        this.count--;
                                    }
                                    else
                                    {
                                        this.codeflag = true;
                                        clearInterval( this.timer );
                                        this.timer = null;
                                    }
                                }, 1000 )
                            }
                        }
                        else
                        {
                            let name = res.data.message;
                            this.checkTips( name, 'warning' );
                        }
                    } )
                }
            },
            butReq() {
                let telReg = /^1[3|4|5|6|7|8|9]\d{9}$/;
                let name = '';
                let code = sessionStorage.getItem( 'code' );

                if ( this.password == '' || this.Qpassword == '' || this.vcode == '' )
                {
                    name = '必填项不能为空！';
                    this.checkTips( name, 'warning' );
                }
                else if ( !telReg.test( this.usertel ) )
                {
                    name = '手机号格式错误！';
                    this.checkTips( name, 'warning' );
                }
                else if ( this.password != this.Qpassword )
                {
                    name = '两次输入密码不一致！';
                    this.checkTips( name, 'warning' );
                }
                // else if ( this.vcode != code )
                // {
                //     let name = '验证码错误！';
                //     this.checkTips( name, 'warning' );
                // }
                else
                {
                    let params = {}
                    if ( this.parentName.type == 1 )
                    {
                        params = {
                            code: this.vcode,
                            phone: this.usertel,
                            password: this.password,
                        }

                        console.log( params )

                        this.$api.user.ChangePassword( params ).then( res =>
                        {
                            console.log( res )
                            if ( res.data.code == 0 )
                            {
                                let name = '修改成功，请重新登录';
                                this.checkTips( name, 'success' );
                                this.$router.replace(
                                {
                                    path: '/login'
                                } )
                            }
                            else
                            {
                                let name = res.data.message;
                                this.checkTips( name, 'warning' );
                            }
                        } )
                    } else if (this.parentName.type == 2) {
                        // 设置支付
                        params = {
                            code: this.vcode,
                            phone: this.usertel,
                            payPassword: this.password,
                        }

                        console.log( params )

                        this.$api.user.ChangePayPassword( params ).then( res =>
                        {
                            console.log( res )
                            if ( res.data.code == 0 )
                            {
                                let name = '设置完成';
                                this.checkTips( name, 'success' );
                                this.closeaddress()
                            }
                            else
                            {
                                let name = res.data.message;
                                this.checkTips( name, 'warning' );
                            }
                        } )
                    }
                }
            },
            checkTips( name, type )
            {
                this.$message(
                {
                    message: name,
                    type: type
                } );
            },
            // +--------------------------------------
            closeaddress()
            {
                this.$emit( 'childFn', this.bol )
            }

        }
    }
</script>